import styled from 'styled-components';

import * as UK from 'components/primitives/content';
import { DaDataUiKit } from 'components/primitives/dadata-uikit/DaDataUiKit';
import { Select } from 'components/uikit/Form/Select/Select';
import { TooltipHover } from 'components/uikit/Tooltip/TooltipHover/TooltipHover';
import { InfoLightSvg } from 'assets/img';

export const Wrapper = styled.div`
  background: var(--color-grey-1);
  padding: 16px;
  border-radius: 8px;
`;

export const Title = styled.h3`
  font: var(--font-heading-large-20_1);
  margin-bottom: 15px;
  display: flex;
  align-items: center;
`;

export const Row = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 8px;

  & > * {
    flex: 1;
    max-width: 100%;
  }

  ${(p) => {
    if (p.joined) {
      return `
        gap: 2px;

        select {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }

        input {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      `;
    }
  }}
`;

export const Controls = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

export const SelectStyled = styled(Select)``;

export const MaskStyled = styled(UK.Mask)`
  ${(p) => (p.disabled ? 'border-color: var(--color-grey-4);' : '')}
`;

export const InfoIcon = styled(InfoLightSvg)`
  width: 20px;
  height: 20px;
  opacity: 0.7;
  font-size: 0;
  margin-left: 8px;

  * {
    fill: var(--color-grey-6);
    transition: fill 0.2s;
  }
`;

export const TooltipHoverStyled = styled(TooltipHover)`
  max-width: 300px;
`;

export const DaDataAddressInput = styled(DaDataUiKit).attrs({ theme: '2' })``;
